import { render, staticRenderFns } from "./Framework.vue?vue&type=template&id=065242f8&scoped=true"
import script from "./Framework.vue?vue&type=script&lang=js"
export * from "./Framework.vue?vue&type=script&lang=js"
import style1 from "./Framework.vue?vue&type=style&index=1&id=065242f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065242f8",
  null
  
)

export default component.exports